import {
  TASKPANE_API_ENDPOINTS,
  getApiAuthCredentials,
  createApiHeaders,
  createApiFetchOptions,
  createApiUrl,
} from "../services/apiConfig";
import logger from "../../logger";

export const fetchAllReports = async (companyId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const queryParams = companyId ? { companyId } : {};
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.ALL_REPORTS, queryParams);
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from API");
    }

    let reportsArray = [];
    if (Array.isArray(data)) {
      reportsArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      reportsArray = data.data;
    } else if (data.reports && Array.isArray(data.reports)) {
      reportsArray = data.reports;
    } else if (data.metrics && Array.isArray(data.metrics)) {
      // Back-compat if API still returns `metrics` key
      reportsArray = data.metrics;
    } else if (data && typeof data === "object") {
      reportsArray = [data];
    }

    return reportsArray;
  } catch (error) {
    logger.error("Error fetching reports:", error);
    throw error;
  }
};

export const fetchSelectedReport = async (reportId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.REPORTS_BY_ID, {
      reportId: reportId.trim(),
    });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const result = await response.json();

    if (!result) {
      throw new Error("No data returned from API");
    }

    let reportObject = null;

    if (result && typeof result === "object") {
      if (result.data && typeof result.data === "object" && !Array.isArray(result.data)) {
        reportObject = result.data;
      } else if (result.data && Array.isArray(result.data) && result.data.length > 0) {
        reportObject = result.data[0];
      } else if (result.reports && Array.isArray(result.reports) && result.reports.length > 0) {
        reportObject = result.reports[0];
      } else if (Array.isArray(result) && result.length > 0) {
        reportObject = result[0];
      } else if (typeof result === "object" && !Array.isArray(result) && !result.data) {
        reportObject = result;
      }
    }

    if (!reportObject || typeof reportObject !== "object" || Array.isArray(reportObject)) {
      throw new Error("No report data found in API response");
    }

    return reportObject;
  } catch (error) {
    logger.error("Error fetching selected report:", error);
    throw error;
  }
};
